<!-- Fixed navbar -->
<header>
  <div class="container ai-center d-flex jc-space-between">
    <a class="hedaer-brand" [routerLink]="linkNavbarBrand">
      <img src="./assets/img/nivelics.png" alt="nivelics" width="774" height="178" />
    </a>
    <ng-content select="[navbarItem]"></ng-content>
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-content select="[navbarItem]"></ng-content>
    </mat-menu>
  </div>
</header>
